export default __webpack_public_path__ + "static/media/project-img.faf7b817.png";